import i18n from "@/i18n";
import { CardVue } from "fs-pb-vue2/vueModels/contracts/CardVue";
import { ContractsTypes } from "fs-pb-vue2/data/enums/contractsTypes";
import cardState from "fs-pb-vue2/filters/cardState.filter";
import { DiTokens } from "fs-pb-vue2/services/diTokens";
import { DeclarationPropertiesTypes } from "fs-pb-vue2/data/enums/declarationPropertiesTypes";
import {OperationsApi} from "fs-pb-vue2/services/api/OperationsApi";
import { OperationRequestData } from "fs-pb-vue2/data/operationRequestData";
import { Prop, Watch } from "vue-property-decorator";
import { container } from "@/inversify.config";
import IAlertService from "fs-pb-vue2/services/alert/IAlertService";
import { RequestParamsModel } from "fs-pb-vue2/models/statement/requestParamsModel";
import { ContractsApi } from "fs-pb-vue2/services/api/ContractsApi";

/** Модель представления счета */
export class CardVueGB extends CardVue {

  /**
   * Сервис вывода уведомлний
   */
  get alertService(): IAlertService {
    return container.get<IAlertService>(DiTokens.AlertService);
  }

  payAction(): void {
    if (this.contract.Data.ContractType === 2 || this.contract.Data.ContractType === 1) 
        this.$router.push(`/operation/0/${this.configStore.apiData.OperationCodeOfToContract}?contract=${this.contract.Data.ReferenceId}`)
    else
        this.$router.push(`/payments?contract=${this.contract.Data.ReferenceId}`)
  }

  get historyOnDisplay(): boolean {
    return this.$route.query.history === 'true';
  }

  get limitsOnDisplay(): boolean {
    return this.$route.query.limits === 'true';
  }

  get reqsOnDisplay(): boolean {
    return this.$route.query.reqs === 'true';
  }

  get windowWidthCalc(): number {
    return window.innerWidth;
  }

  get mobileOnDisplay(): boolean {
    return (!this.historyOnDisplay) || this.windowWidthCalc > 970;
  }

  loadHistory(): void {
    this.$router.push({path: this.$route.fullPath, query: { 'history': 'true' }})
  }

  changeDisplayCard(): void {
    this.mainCardOnDisplay = !this.mainCardOnDisplay;
  }

  showNumber: boolean = false;

  mainCardOnDisplay: boolean = true;

  cardVisibleDigits: string = '';

  async showNumberFunc(): Promise<void> {
    this.showNumber = true;
    try {
      await this.loadCardDetails();

      const inp = document.createElement('input')
      inp.value = this.cardVisibleDigits;
      document.body.appendChild(inp)
      inp.select()

      if (document.execCommand("copy") && this.cardVisibleDigits) {
        this.alertService.success('Номер карты скопирован');
      } else {
        this.showNumber = false;
        this.alertService.error('Ошибка получения номера карты');
      }
      document.body.removeChild(inp)
    } catch(e: any) {
      this.showNumber = false;
      this.alertService.error(e.message);
    }
  }

  getCardState(state: any): string {
    return cardState(state);
  }

  async callAction(action: () => Promise<void>) {
    await action();
  }

  async getCVV(): Promise<void> {
    this.alertService.info(i18n.t('main.cards.actions.cvvIsNotAvailable').toString());
  }

  async loadCardDetails() {
    try {
      const params: RequestParamsModel = new RequestParamsModel({ take: 1, skip: 0, sortType: 1, respondentName: 'GetCardDetails', cardId: this.card.Data.Id });
      const respData: any = await ContractsApi.fillList(params);

      if (respData && respData.result === "ok" && respData.data && respData.data.Data.Properties && respData.data.Data.Properties.cardNumber) {
        const cardNumber: string = respData.data.Data.Properties.cardNumber;
        this.cardVisibleDigits = cardNumber.replace(/(.{4})/g, "$1 ");
      }
    } catch(e: any) {
      this.alertService.error(e.message);
    }
  }

  /**
 * Действия с картой
 * @returns {Array<any>} - массив действий
 */
  get actions(): Array<any> {
    const actions: Array<any> = [];
    if (this.contract && this.card) {
      if (this.card.IsActive) {
        /**Блокировка карты */
        actions.push({
          text: i18n.t("main.cards.actions.blockCard"),
          iconClass: "block-card-icon",
          action: () => {
            this.dialogContent = new Object({
              vueName: "CardBlockModal",
              params: {
                isBlock: true,
                contract: this.contract,
                card: this.card
              }
            });
            this.dialog = true;
          }
        });
        if (this.card.Data.selectMode !== 0) {
          /**Выбрать категорию кэшбэк */
          actions.push({
            text: i18n.t("main.cards.actions.chooseCashBack"),
            iconClass: "choose-card-icon",
            action: () => {
              this.dialogContent = new Object({
                vueName: "ChooseCashBack",
                params: { contract: this.contract, card: this.card }
              });
              this.dialog = true;
            }
          });
        }
        if (this.card.Data.transferMode !== 0 && this.card.Data.transferMode == 2) {
          /**Потратить кэшбэк */
          actions.push({
            text: i18n.t("main.cards.actions.spendCashBack"),
            iconClass: "spend-card-icon",
            action: () => {
              this.$router.push(`/operation/0/${this.configStore.apiData.OperationCodeOfTransferCashBack}?contract=${this.contract.Data.ReferenceId}&card=${this.card.Data.ReferenceId}`);
            }
          });
        }
        // if (
        //   this.configStore.apiData.OperationCodeOfCardPinCode && this.card.Data.MainCard != '0'
        // ) {
        //   // /**Сменить пин код */
        //   actions.push({
        //     text: i18n.t("main.cards.actions.changePin"),
        //     iconClass: "change-pin-icon",
        //     action: () => {
        //       // this.dialogContent = new Object({
        //       //   vueName: "CardPinModal",
        //       //   params: { card: this.card, contract: this.contract }
        //       // });
        //       // this.dialog = true;
        //       this.$router.push(`/operation/0/${this.configStore.apiData.OperationCodeOfCardPinCode}`);
        //     }
        //   });
        // }
        /**Установить лимиты */
        actions.push({
          text: i18n.t("main.cards.actions.setLimits"),
          iconClass: "set-limits-icon",
          action: () => {            
            this.dialogContent = new Object({
              vueName: "CardLimitsModal",
              params: { 
                card: this.card,
                cardRefId: this.card.Data.ReferenceId,
                contract: this.contract,
              }
            })
            this.$router.push({path: this.$route.fullPath, query: { 'limits': 'true' }})
          },
        });
        if (this.card.Data['MainCard'] != '0') {
          /**Действие запроса реквизитов счета */
          actions.push({
            text: i18n.t("main.cards.actions.requisits"),
            iconClass: "def-action-icon",
            action: () => {
              this.$router.push({ path: this.$route.fullPath, query: { 'reqs': 'true' } });
            }
          });
        }
      } else if (this.card.IsBlocked) {
        /**Блокировка карты */
        actions.push({
          text: i18n.t("main.cards.actions.unblockCard"),
          iconClass: "block-card-icon",
          action: () => {
            this.dialogContent = new Object({
              vueName: "CardBlockModal",
              params: {
                isBlock: false,
                contract: this.contract,
                card: this.card
              }
            });
            this.dialog = true;
          }
        });
      }

      if (!this.card.IsIssued) {
        /**Действие запроса выписки по счету*/
        actions.push({
          text: i18n.t("main.cards.actions.statement"),
          iconClass: "statement-icon",
          action: () => {
            // this.statementMode = true;
            this.$router.push(
              `/statement/${this.contract.Data.Id}/${this.card.Data.Id}`
            );
          }
        });
      }
    }
    return actions;
  }

}